import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import Seo from "@/components/Seo";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <Layout>
      <Seo title="Seite nicht gefunden | KeyMaster KFZ" description="Die gewünschte Seite wurde nicht gefunden." path="/404" />
      <section className="flex min-h-[70vh] flex-col items-center justify-center bg-[#050505] px-5 text-center pt-24">
        <p className="font-heading text-[8rem] font-black leading-none text-volt sm:text-[12rem]">404</p>
        <h1 className="font-heading text-3xl font-bold uppercase text-white">Seite nicht gefunden</h1>
        <p className="mt-3 max-w-md font-body text-neutral-400">
          Die aufgerufene Seite existiert nicht. Kehre zur Startseite zurück.
        </p>
        <Link to="/" data-testid="notfound-home-btn"
          className="mt-8 inline-flex items-center gap-2 bg-volt px-8 py-4 font-body text-sm font-bold uppercase tracking-wide text-black transition-transform hover:scale-[1.03]">
          <ArrowLeft className="h-5 w-5" /> Zur Startseite
        </Link>
      </section>
    </Layout>
  );
}
